import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { setItem, getItem } from 'src/reducers/common/itemReducer';
import PayrollDetailShow from './components/payroll/PayrollDetailShow';

const PayrollDetail = ({ dispatch, values, location }) => {
  const searchParams = new URLSearchParams(location.search);
  const payrollId = parseInt(searchParams.get('id'), 10);
  const yearFromParams = parseInt(searchParams.get('year'), 10);

  const year = yearFromParams || values.yearsList[0];
  const payrollFromParams = values?.allPayrolls.find(payroll => payroll.id === payrollId) || [];

  dispatch(
    setItem(REDUCER_NAME, {
      ...values,
      selectingPayroll: payrollId ? payrollFromParams : values.allPayrolls[0] || {},
      selectedYear: payrollId ? moment(payrollFromParams.paymentDate).year() : year,
      location
    })
  );

  return <PayrollDetailShow />;
};

const mapStateToProps = state => ({
  selectedPayrollId: (getItem(REDUCER_NAME, state) || {})?.selectedPayrollId,
  selectedYear: (getItem(REDUCER_NAME, state) || {})?.selectedYear
});

export default connect(mapStateToProps)(PayrollDetail);
